import type { UniqueIdentifier } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { Slot } from '@radix-ui/react-slot'
import * as React from 'react'

import { cn } from '~/styled'

export type TSortableItemProps = {
  id: UniqueIdentifier
  asChild?: boolean
  isDragHandle?: boolean
  disabled?: boolean
  className?: string
  style?: Pick<React.HTMLAttributes<HTMLDivElement>, 'style'>
}

export const SortableItem = ({
  id,
  asChild = false,
  className,
  style,
  isDragHandle = false,
  disabled,
  ...rest
}: React.PropsWithChildren<TSortableItemProps>) => {
  const { transform, setNodeRef, isDragging, listeners, attributes } =
    useSortable({ id })

  const Component = asChild ? Slot : 'div'
  return (
    <Component
      ref={setNodeRef}
      style={{
        ...style,
        '--scale': 1,
        '--translate-x': transform?.x || 0,
        '--translate-y': transform?.y || 0
      }}
      data-dragging={isDragging}
      data-disabled={disabled}
      {...(isDragHandle && !disabled ? listeners : {})}
      {...(isDragHandle && !disabled ? attributes : {})}
      {...rest}
      className={cn(
        'translate-x-[calc(var(--translate-x)*1px)]',
        'translate-y-[calc(var(--translate-y)*1px)]',
        'scale-(--scale)',
        isDragging && 'z-5',
        'disabled:**:pointer-events-none',
        'disabled:cursor-not-allowed',
        'disabled:opacity-30',
        isDragHandle && (isDragging ? 'cursor-grabbing' : 'cursor-grab'),
        className
      )}
    />
  )
}

SortableItem.displayName = 'SortableItem'
